import PrivateHeader from './header/header'
import PrivateAside from './aside/aside'
import QuestionModal from '@/components/general/question-modal/question-modal'

export default {
	name: 'private',
	data () {
		return {}
	},
	methods : {},
	components : {
		PrivateHeader,
		PrivateAside,
		QuestionModal
	}
}


// WEBPACK FOOTER //
// ./src/components/private/script.js